export default __webpack_public_path__ + "static/media/radiant-bright-purple-orange.d4600279.jpg";